<template>
    <div id="gnb">
        <div class="gnb-container">
            <div class="gnb-contents">
                <div class="logo">
                    <!-- :src="require('../assets/logo.jpg')" -->
                    <img src="../assets/logo.svg" alt="로고" @click="$router.push('/main')">
                </div>
                <div class="cell-center">

                </div>
                <div class="cell-right">
                    <router-link
                    v-for="(item, i) in gnbEl"
                    :key="i"
                    tag="div"
                    class="router-link-item"
                    :to="item.url"
                    >
                    {{item.name}}
                    </router-link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                gnbEl: [
                    { name: `전시정보`, url: `/about` },
                    { name: `아카이브`, url: `/archive` },
                ]
            }
        }
    }
</script>

<style scoped>
@media all and (max-width: 767px) {
    #gnb {
        width: 100vw;
        height: 56px;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
        background: #000;
    }
    .gnb-container {
        width: 100vw;
        height: 56px;
        display: table;
    }
    .gnb-contents {
        width: 100vw;
        height: 56px;
        margin: 0 auto;
    }
    .gnb-contents > div {
        height: 56px;
        display: table-cell;
        vertical-align: middle;  
    }
    .gnb-contents .logo {
        width: 6vw;
    }
    .gnb-contents .logo img {
        height: 32px;
        cursor: pointer;
        margin: 0 0 0 4vw;
    }
    .gnb-contents .cell-center {
        width: 20vw;
    }
    .gnb-contents .cell-right {
        width: 70vw;
        text-align: right;
    }
    .router-link-item {
        display: inline-block;
        padding: 4px 0;
        margin: 0 16px;
        cursor: pointer;
        font-size: 0.8rem;
        border-bottom: 3px solid rgba(0, 0, 0, 0);
    }
    .router-link-exact-active {
        font-weight: 900;
        border-bottom: 3px solid #ed86a1;
  }
}

@media all and (min-width: 768px) {
    #gnb {
        width: 100vw;
        height: 36px;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
    }
    .gnb-container {
        width: 100vw;
        height: 36px;
        display: table;
    }
    .gnb-contents {
        width: 96vw;
        height: 72px;
        margin: 0 auto;
    }
    .gnb-contents > div {
        height: 72px;
        display: table-cell;
        vertical-align: middle;  
        font-size: 1rem;
    }
    .gnb-contents .logo {
        width: 6vw;
    }
    .gnb-contents .logo img {
        height: 32px;
        cursor: pointer;
    }
    .gnb-contents .cell-center {
        width: 66vw;
    }
    .gnb-contents .cell-right {
        width: 30vw;
        text-align: right;
    }
    .router-link-item {
        display: inline-block;
        padding: 8px 0;
        margin: 0 32px;
        cursor: pointer;
        border-bottom: 4px solid  rgba(0, 0, 0, 0);
    }
    .router-link-exact-active {
        font-weight:900;
        border-bottom: 4px solid #ed86a1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GlobalNav.vue